
import 'reflect-metadata';
import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({
  name: 'TheFooter',
})
export default class TheFooter extends Vue {
  // DATA
  private year: string = (new Date()).getFullYear().toString();

  @Getter('projectName')
  private product: string;

  @Getter('productVersion')
  private version: string;
}
